/**
 * --------------------------------------------------------------------------
 * Basic Modules: ProductGallery.js
 * --------------------------------------------------------------------------
 */

import Util from "./Util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG         = false;
const NAME          = 'productGallery';
const DATA_KEY      = 'productGallery';
const EVENT_KEY     = `.${DATA_KEY}`;
const LOG_KEY       = `[${NAME}]`;

const Default = {
};

const Event   = {
    RESIZE          :  `resize${EVENT_KEY}`,
};

const ClassName = {
};

const Selector = {
    TOGGLE          : '.js-product-gallery-for',
    NAV_CONTAINER   : '.js-product-gallery-nav',
};

const DataAttr = {};

/**
 * @type {constructor}
 */
class ProductGallery {

    /**
     * Constructor.
     *
     * @param element
     * @param config
     */
    constructor(element, config)
    {
        DEBUG && console.log(LOG_KEY, 'init');

        this.resizeTimeout = null;

        this._element   = element;
        this._nav       = document.querySelector(Selector.NAV_CONTAINER);
        this._config    = this._getConfig(config);

        //this._addEventListeners();
        this._setup();
    }


    destroy() {
        this.$el.off('.' + name);
        this.$el.find('*').off('.' + name);

        this.$el.removeData(name);
        this.$el = null;
    }

    // Private

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    _isMobile() {
        return (Util.viewport === 'mobile' || Util.viewport === 'phablet');
    }

    _addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this._handleWindowResize(event));
    }

    _setup() {

        let $carousel = $(this._element);

        $carousel
            .slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                adaptiveHeight: false,
                asNavFor: Selector.NAV_CONTAINER
            })
        ;

        if (this._nav) {
            $(this._nav).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: Selector.TOGGLE,
                dots: false,
                arrows: true,
                centerMode: false,
                focusOnSelect: true,
                variableWidth: true,
            });
        }

        $carousel.find('.item-slick').zoom();
    }

    /**
     * Handle the resizing of the window
     */
    _handleWindowResize() {

        if (this.resizeTimeout) return;

        this._setup();

        this.resizeTimeout = setTimeout(() => {
            this.resizeTimeout = null;
        }, 500);
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        ProductGallery._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new ProductGallery(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = ProductGallery._jQueryInterface;
$.fn[NAME].Constructor = ProductGallery;


export default ProductGallery;
